const IMAGE_BASE_URL = "https://api.toursbouillon.fr"
// URL de base pour les images (sans /api)
// const IMAGE_BASE_URL = 'http://localhost:3001';
// PROD const IMAGE_BASE_URL = 'https://api.toursbouillon.fr';

/**
 * Construit l'URL complète d'une image stockée dans le backend
 * @param {string} imagePath - Le chemin de l'image (ex: "/images/logo.png")
 * @returns {string} L'URL complète de l'image
 */
export const getBackendImageUrl = (imagePath) => {
    // Si imagePath est null, undefined ou vide, retourner null
    if (!imagePath) {
        return null;
    }
    
    // Si le chemin commence déjà par http, on le retourne tel quel
    if (imagePath.startsWith('http')) {
        return imagePath;
    }
    
    // Si le chemin commence par /, on l'ajoute directement à l'IMAGE_BASE_URL
    if (imagePath.startsWith('/')) {
        return `${IMAGE_BASE_URL}${imagePath}`;
    }
    
    // Sinon, on ajoute /images/ au début
    return `${IMAGE_BASE_URL}/images/${imagePath}`;
};

/**
 * Construit l'URL d'une image de galerie
 * @param {string} imagePath - Le nom du fichier image
 * @returns {string} L'URL complète de l'image de galerie
 */
export const getGalleryImageUrl = (imagePath) => {
    return getBackendImageUrl(`/gallery/${imagePath}`);
};

/**
 * Construit l'URL d'une image de menu
 * @param {string} imagePath - Le nom du fichier image
 * @returns {string} L'URL complète de l'image de menu
 */
export const getMenuImageUrl = (imagePath) => {
    return getBackendImageUrl(`/${imagePath}`);
}; 